import { Component } from '@angular/core';
import { EquipmentPanelComponent } from '../../../generic/equipment-panel/equipment-panel.component';
import { NewSearchComponent } from '../../../generic/new-search/new-search.component';
import { ChatPanelComponent } from '../../../generic/chat-panel/chat-panel.component';
import { ResourcesPanelComponent } from '../../../generic/resources-panel/resources-panel.component';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { appLauncherSuccess } from '../../../../store/appLauncher/appLauncher.actions';
import { app } from '../../../../../../server';
import {jwtDecode} from 'jwt-decode';
import { MatDialog } from '@angular/material/dialog';
import { map, filter, Observable } from 'rxjs';
import { AppLauncherInfo } from '../../../../store/appLauncher/appLauncher.model';
import { CommonModule } from '@angular/common';

interface DecodedToken {
  exp?: number; // expiration (in seconds since epoch)
  [key: string]: any; // allow other claims
}

interface JwtPayload {
   sub: string;
   equipment_code: string;
   api_key: string;
   iat: number;
   exp: number;
   iss: string;
 }

export function isTokenExpired(token: string): boolean {
  try {
    const decoded = jwtDecode<DecodedToken>(token);

    if (!decoded.exp) {
      // no exp claim → treat as expired
      return true;
    }

    const now = Math.floor(Date.now() / 1000); // current time in seconds
    return decoded.exp < now;
  } catch (err) {
    // invalid token → treat as expired
    return true;
  }
}

@Component({
  selector: 'app-equipment',
  standalone: true,
  imports: [EquipmentPanelComponent, NewSearchComponent, ChatPanelComponent, ResourcesPanelComponent,CommonModule],
  templateUrl: './equipment.component.html',
  styleUrls: ['./equipment.component.css']
})


export class EquipmentComponent {
  isPunchOut$: Observable<boolean>;

  constructor(
    private route: ActivatedRoute,
    private store: Store,
    private router: Router,
    private dialog: MatDialog,
    private store2: Store<{appLauncher: AppLauncherInfo}>
  ) {
    this.isPunchOut$ = this.store2.select('appLauncher').pipe(
      map(appLauncherInfo => appLauncherInfo.isPunchOut)
    );
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      // If equipment code was passed in as param for this path, we need to execute app launcher logic. Otherwise its web app and do nothing
      if (params['equipment_code']) {
        try{
          const equipment_code = params['equipment_code'] || ''
          const token = params['token']

          // If no token in the parameters display to user their punch out url is incorrect
          if (!token) {
            throw new Error('Token is missing in url');
          }
          
          // Check if the token is expired 
          if (isTokenExpired(token)) {
            console.log("Token is expired");
            throw new Error('Token is expired');
          } else {
            console.log("Token is still valid");
          }
          
          // Decode the token
          console.log(jwtDecode<JwtPayload>(token));
          const raw_token = jwtDecode<JwtPayload>(token)
          const user = raw_token['sub'] || ''
          const api_key = raw_token['api_key'] || ''
          const isPunchOut = true;
          const wasSuccess = true;
          this.store.dispatch(appLauncherSuccess({
            user,
            equipment_code,
            api_key,
            isPunchOut,
            wasSuccess
          }));
        }catch(error){
          // This triggers for no passed in token or malformed token (decode error)
          const isPunchOut = true;
          const wasSuccess = false;
          const user =  ''
          const api_key = ''
          const equipment_code = ''
          const errorMessage = 'Token Missing/Malformed/Expired'
          const errorMessage2 = ''
          this.store.dispatch(appLauncherSuccess({
            user,
            equipment_code,
            api_key,
            isPunchOut,
            wasSuccess
          }));
          console.log('Error in the token that was passed in')
          this.router.navigate(['/technician/error'], { 
            queryParams: { message: errorMessage,
              message2: errorMessage2
             }
          });
          throw error
        }
      } 
    });
  }
}
